import { OrderedMap, Map } from 'immutable';
import { records as jobRecords } from '@saucelabs/sl-module-archived-jobs';
import { records as userRecords } from '@saucelabs/sl-module-user';

import * as types from './types';
import * as filterTypes from './../filters/types';

export const initialState = Map({
  users: Map(),
  initialized: false,
  jobsLoading: true,
  error: null,
  results: OrderedMap(),
  total: 0,
});

export const archivesReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case types.INITIALIZED:
      return state.set('initialized', true);
    case types.JOBS.REQUEST:
      return state.withMutations((newState) => {
        newState
          .set('jobsLoading', true)
          .set('error', initialState.get('error'));
      });
    case types.JOBS.SUCCESS: {
      const users = state.get('users');
      const { jobs, total } = payload;
      const newResults = jobs.reduce((acc, job) => {
        const { id } = job;
        acc[id] = new jobRecords.ArchivedRdcJobRecord({
          ...job,
          build: job.build_name,
          owner: users.get(job.owner_id)?.displayName(),
        });
        return acc;
      }, {});
      const results = OrderedMap(newResults).sort(
        (prev, next) => new Date(prev.get('date')) - new Date(next.get('date')),
      );

      return state.withMutations((newState) => {
        newState
          .set('results', results)
          .set('jobsLoading', false)
          .set('total', total)
          .set('error', initialState.get('error'));
      });
    }
    case types.JOBS.FAILURE:
      return state.withMutations((newState) => {
        newState
          .set('results', initialState.get('results'))
          .set('total', initialState.get('total'))
          .set('jobsLoading', false)
          .set('error', payload);
      });
    case filterTypes.GET_USERS.SUCCESS: {
      const users = payload.results.reduce((acc, user) => {
        acc[user.id] = new userRecords.UserRecord(user);
        return acc;
      }, {});
      return state.set('users', Map(users));
    }
    case types.CLEANUP:
      return initialState;
    default:
      return state;
  }
};

export default archivesReducer;
